<template>
  <transition @enter="enter" appear>
    <div class="BetterLanscape" v-if="show">
      <div class="BetterLanscape__logo">
        BETTER IN LANDSCAPE
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BetterLanscape',
  computed: {
    show() {
      // return this.$root.$agent.mobile && this.orientation == 'portrait' && this.neverSeen
      // return this.neverSeen
      return false
    }
  },
  data: () => ({
    neverSeen: true,
  }),
  methods: {
    enter(el, done) {
      TweenMax.to(this.$el, 1, { alpha: 1 })
      TweenMax.to(this.$el, 1, { delay: 2, alpha: 0, onComplete: () => {
        this.neverSeen = false
        done()
      }})
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.BetterLanscape
  background-color rgba(#000, .8)
  position fixed
  z-index 999
  height 100%
  width 100%
  opacity 0

  &__logo
    color #fff
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)

</style>



// WEBPACK FOOTER //
// src/components/betterLandscape/BetterLandscape.vue